import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	success: {
		id: 'portfolio-3-dependency-settings.ui.success-flags.success',
		defaultMessage: 'Dependency settings updated',
		description: 'Message for when the dependency settings is successfully updated.',
	},
});
